import { Router } from "@angular/router";
import { KeycloakService } from "keycloak-angular";
import { ConfigService } from "../config/config.service";
import { UtilitiesService } from "../utilities.service";
import {
  KEYCLOAK_CHECK_LOGIN_IFRAME,
  KEYCLOAK_CLIENT_ID,
  KEYCLOAK_DEFAULT_REALM,
  KEYCLOAK_ON_LOAD,
} from "./keycloak.constants";
import {
  clearAuthHandshakeStorage,
  installInMemoryAuthTokenStorage,
  stripPersistedAuthTokens,
} from "./auth-token-storage";

export function initializeKeycloak(
  keycloak: KeycloakService,
  configService: ConfigService,
  utilityService: UtilitiesService,
  router: Router,
  clientIdOverride?: string
): () => Promise<boolean> {
  return async () => {
    try {
      installInMemoryAuthTokenStorage();

      // Load runtime config.json before reading any configuration values.
      // This allows the same Docker image to be deployed to any environment
      // by supplying different values via a Kubernetes ConfigMap or env vars.
      await configService.whenReady();

      const keycloakUrl = configService.getConfig("keycloakUrl");
      // console.log("ENVIRONMENT", configService.getConfig("production"), keycloakUrl);
      // Extract the realm name dynamically from the URL
      // const extractedRealm = configService.getConfig("isDomainResolver")
      //   ? utilityService?.extractRealmFromUrl()
      //   : sessionStorage.getItem("selectedRealm");
      const extractedRealm = utilityService?.extractRealmFromUrl();
      const realmSlug =
        extractedRealm && extractedRealm !== KEYCLOAK_DEFAULT_REALM
          ? extractedRealm
          : KEYCLOAK_DEFAULT_REALM;
      const realm = `accello360-${realmSlug}-realm`;
      const clientId = clientIdOverride || KEYCLOAK_CLIENT_ID;

      const initOptions = {
        config: {
          url: keycloakUrl,
          realm: realm,
          clientId: clientId,
        },
        initOptions: {
          onLoad: KEYCLOAK_ON_LOAD,
          checkLoginIframe: KEYCLOAK_CHECK_LOGIN_IFRAME,
        },
        enableBearerInterceptor: true,
        bearerExcludedUrls: ["/assets"],
      };

      const authenticated = await keycloak.init(initOptions);
      stripPersistedAuthTokens();
      if (authenticated) {
        clearAuthHandshakeStorage();
        return true;
      }
      console.log("Session invalid. Redirecting to login.");
      return false;
    } catch (error) {
      console.error("Keycloak initialization failed", error);
      return false;
    }
  };
}
